import script from "./NastaPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./NastaPill.vue?vue&type=script&setup=true&lang=ts"

import "./NastaPill.vue?vue&type=style&index=0&id=7b031723&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b031723"]])

export default __exports__